import { useFile } from 'helpers';

export interface VideoProps {
  src?: any;
  [key: string]: any;
}

export const Vid = ({ src, ...rest }: VideoProps) => {
  const video = useFile(src);
  if (!video) return <></>;

  return <video src={video} {...rest} />;
};
